import { useAuth } from '@/containers'
import useCurrencyNumber from '@/hooks/useCurrencyNumber'
import type { VoucherItem as CouponType } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'

interface VoucherItemProps {
  data: CouponType
  className?: string
  onChoose?: () => void
  onApply?: () => void
}

const VoucherItem = ({
  data,
  className = '',
  onChoose,
  onApply,
}: VoucherItemProps) => {
  const { token } = useAuth()
  const format = useCurrencyNumber()

  const { percentValue, showValue, fixedValue, name } = data
  const _fixedValue = fixedValue ? format(fixedValue) : ''

  const haveButton = onChoose || onApply

  return (
    <div
      className={`flex items-center gap-4 bg-voucher bg-full bg-no-repeat ${className}`}
    >
      <div className='flex grow flex-col'>
        {showValue && (
          <div className='w-full text-white-400'>
            <span className='font-bold '>
              {'Giảm ngay '}
              {(percentValue && `${percentValue}%`) || _fixedValue}
            </span>

            {percentValue && _fixedValue && (
              <span className='italic'>
                ({`~${!!_fixedValue && _fixedValue}`})
              </span>
            )}
          </div>
        )}
        <span className={`line-clamp-${showValue ? '1' : '2'} text-white-400`}>
          {getTranslate(name)}
        </span>
      </div>

      {haveButton && !token && (
        <button
          className='!min-w-fit rounded-full bg-black-400 bg-opacity-30 px-4 py-2 text-white'
          onClick={onApply}
        >
          Lấy Voucher
        </button>
      )}

      {/* {haveButton && token && (
        <Button
          color='success'
          variant='text'
          className='!min-w-fit'
          onClick={onChoose}
        >
          Đã lấy
        </Button>
      )} */}
    </div>
  )
}

export default VoucherItem
